/** Restore editable pin state from the current Document, never a historical snapshot. */
import { parseDigitPin, type AnimatorDocument, type DigitName } from '@harryhausen/kernel';
import { initialHandUi, type HandUiState } from './hands-panel-state.js';
export function savedHandState(doc: AnimatorDocument, handBone: string): HandUiState | null {
  const hand = doc.target.hands.find((h) => h.handBone === handBone);
  if (!hand) return null;
  const entries = doc.target.confirmations.filter((c) => c.scope === handBone);
  const tips = entries.filter((c) => c.target === 'digitAssignment');
  if (tips.length === 0) return null;
  const knuckles = new Map(
    entries
      .filter((c) => c.target === 'digitKnuckle')
      .map((c) => {
        const p = parseDigitPin(c.value)!;
        return [p.digit, p.tip];
      }),
  );
  const wristEntry = entries.find((c) => c.target === 'wristStation');
  const opposition = entries.find((c) => c.target === 'thumbOpposition');
  return {
    ...initialHandUi(),
    resolution: hand.resolution.value,
    // A partial graft does not record the anatomical digit count. Use the
    // normal five-digit belief so every restored name remains available.
    recenterWrist: entries.some((c) => c.target === 'wristRecenter'),
    wrist: wristEntry ? parseDigitPin(wristEntry.value)!.tip : null,
    thumbOpposition: opposition ? Number(opposition.value) : 90,
    pins: {
      minted: tips.length,
      rejected: [],
      pins: tips.map((c, i) => {
        const p = parseDigitPin(c.value)!;
        return {
          id: `pin-${i + 1}`,
          tip: p.tip,
          knuckle: knuckles.get(p.digit) ?? null,
          digit: p.digit as DigitName,
          named: 'human' as const,
          clusterId: null,
        };
      }),
    },
  };
}
